"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const TextInput_1 = require("./TextInput");
const StyledEyeWrap = app_1.styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  right: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledSvg = app_1.styled.svg `
  color: ${(theme) => theme.stroke};
  cursor: pointer;
`;
const activeSvgStyle = (0, app_1.css) `
  color: ${(theme) => theme.colors.primary.deep};
`;
function EyeSwitcher({ setVisible, visible }) {
    return ((0, jsx_runtime_1.jsx)(StyledEyeWrap, Object.assign({ onClick: () => setVisible((v) => !v) }, { children: (0, jsx_runtime_1.jsxs)(StyledSvg, Object.assign({ css: (0, app_1.css) `
          ${visible && activeSvgStyle}
        `, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentcolor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }), (0, jsx_runtime_1.jsx)("circle", { cx: "12", cy: "12", r: "3" })] })) })));
}
exports.PasswordInput = (0, react_1.forwardRef)((_a, ref) => {
    var { toggle = false } = _a, props = __rest(_a, ["toggle"]);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const EyeElement = (0, react_1.useCallback)(() => (0, jsx_runtime_1.jsx)(EyeSwitcher, { setVisible: setVisible, visible: visible }), [setVisible, visible]);
    return ((0, jsx_runtime_1.jsx)(TextInput_1.TextInput, Object.assign({}, (toggle ? { suffix: (0, jsx_runtime_1.jsx)(EyeElement, {}) } : {}), props, { ref: ref, type: visible ? 'text' : 'password' })));
});
